import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { corporate_landing_path } from '@routes';
import { ClickTarget, click } from '@tracking';

const CorporateInquiry = () => {
  const { trackEvent } = useEventTracking();
  return (
    <div className="-mx-16 mt-48 border-0 border-t-2 border-solid border-grayscale-gray px-16 pt-32 font-suisse-screen text-disclosure-lg text-primary-black sm:mx-0 sm:px-0 sm:pt-16">
      <span className="mr-4">Interested in a group or corporate subscription?</span>
      <a
        href={corporate_landing_path()}
        className="text-primary-magenta visited:text-primary-magenta"
        onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.CorporateInquiry }))}
      >
        Explore options here.
      </a>
    </div>
  );
};

export default CorporateInquiry;
